import React from 'react';
import PropTypes from 'prop-types';
import './StatsTableContent.scss';

const StatsTableContent = ({ stats, titles })=> {
  return (
    <div className='stats-table-content'>
      {titles.map(title => <span key={title} className='stats-table-content__item'>{stats[title] || '-'}</span>)}
    </div>
  );
};

StatsTableContent.propTypes = {
  stats: PropTypes.object,
  titles: PropTypes.array
};

StatsTableContent.defaultProps = {
  stats: {},
  titles: []
};

export default StatsTableContent;
